import { Endpoint } from '../endpoint';
import { CompanyResponse, CompanyId } from '@business/entities/companies';
import { CommonService } from '@business/services';
import {
  ClickupTaskRequest,
  ClickupTeamResponse,
  ClickupFolderResponse,
  ClickupSpaceResponse,
  ClickupListResponse,
  ClickupExtendedListResponse,
  ClickupListMemberResponse,
  ClickupWebhookResponse,
  ClickupListCustomFieldRespone,
  ClickupModule,
} from '@business/entities/clickup';

export function createTask(request: ClickupTaskRequest) {
  return Endpoint.post<any>(`@gc/clickup/create-task`, { data: request });
}

export function getTeams() {
  return Endpoint.get<ClickupTeamResponse[]>(`@gc/clickup/teams`, {});
}

export function getSpaces(team: string) {
  return Endpoint.get<ClickupSpaceResponse[]>(`@gc/clickup/spaces`, { params: { team } });
}

export function getFolders(space: string) {
  return Endpoint.get<ClickupFolderResponse[]>(`@gc/clickup/folders`, { params: { space } });
}

export function getLists(folder: string) {
  return Endpoint.get<ClickupListResponse[]>(`@gc/clickup/lists`, { params: { folder } });
}

export function getSprints() {
  return Endpoint.get<ClickupListResponse[]>(`@gc/clickup/sprints`, {});
}

export function getNewSprints() {
  return Endpoint.get<ClickupListResponse[]>(`@gc/clickup/new-sprints`, {});
}

export function getList(list: string) {
  return Endpoint.get<ClickupExtendedListResponse>(`@gc/clickup/list`, { params: { list } });
}

export function getMembers(list: string) {
  return Endpoint.get<ClickupListMemberResponse[]>(`@gc/clickup/members`, { params: { list } });
}

export function getWebhook() {
  return Endpoint.get<ClickupWebhookResponse[]>(`@gc/clickup/webhook`, { params: {} });
}

export function createWebhook() {
  return Endpoint.post<void>(`@gc/clickup/webhook`, { data: {} });
}

export function deleteWebhook(webhookId: string) {
  return Endpoint.post<void>(`@gc/clickup/delete-webhook`, { data: { webhookId } });
}

export function getCustomFields(list: string) {
  return Endpoint.get<ClickupListCustomFieldRespone[]>(`@gc/clickup/custom-fields`, { params: { list } });
}

export function unSync(data: ClickupTaskRequest) {
  return Endpoint.post<void>(`@gc/clickup/un-sync`, { data });
}
